<template>
  <div class="content">
    <div class="inner_content">
      <div class="header">
        <!-- <div class="box flex" style="align-items:center">
          <div class="title">领取方式：</div>
          <el-select
            v-model="get_type"
            placeholder="请选择"
            size="small"
            class="fixedwidth"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button type="primary" size="small" @click="getLists"
            >筛选</el-button
          >
        </div> -->
        <el-form :model="params" label-width="80px" size="small">
          <el-form-item class="options_item2" label="时间">
            <!-- <el-radio-group
              v-model="params.time"
              size="small"
              style="vertical-align: top;margin-right:15px"
              @change="changeGet"
            >
              <el-radio-button
                v-for="(item, index) in timeType"
                :key="index"
                :label="item.value"
                >{{ item.name }}</el-radio-button
              >
            </el-radio-group> -->
            <el-date-picker
              v-model="dateValue[0]"
              type="date"
              class="date_picker_box"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
            <el-time-picker
              placeholder="时间"
              v-model="timeValue[0]"
              class="time_picker_box"
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              arrow-control
            ></el-time-picker>
            <span style="margin-right:8px">至</span>
            <el-date-picker
              v-model="dateValue[1]"
              type="date"
              class="date_picker_box"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
            <el-time-picker
              placeholder="时间"
              v-model="timeValue[1]"
              class="time_picker_box"
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              arrow-control
            ></el-time-picker>
            <el-button
              size="small"
              type="primary"
              v-show="params.time == 'z'"
              @click="timeSearch()"
              >搜索</el-button
            >
            <el-button size="small" type="primary" @click="chongzhi()"
              >重置</el-button
            >
          </el-form-item>
          <el-form-item label="获取方式" class="options_item3">
            <el-radio-group
              v-model="params.getType"
              size="small"
              @change="changeGet"
            >
              <el-radio-button
                v-for="item in getType"
                :key="item.value"
                :label="item.value"
                >{{ item.name }}</el-radio-button
              >
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="bottom">
        <el-table
          :data="tableData"
          size="small"
          :header-cell-style="setHeader"
          v-loading="loading"
        >
          <el-table-column prop="title" label="券名称"></el-table-column>
          <el-table-column label="券类型" prop="coupon_type_name">
          </el-table-column>
          <el-table-column prop="send_num" label="领取数量"></el-table-column>
          <el-table-column prop="num" label="剩余数量"></el-table-column>

          <el-table-column prop="real_name" label="会员名"></el-table-column>
          <el-table-column prop="mobile" label="手机号"></el-table-column>
          <el-table-column prop="source" label="来源"></el-table-column>
          <el-table-column prop="get_time" label="领取时间"></el-table-column>
          <el-table-column prop="exp_state" label="是否过期"></el-table-column>
          <el-table-column prop="start_time" label="开始时间"></el-table-column>
          <el-table-column prop="end_time" label="结束时间"></el-table-column>
          <el-table-column
            prop="cancel_time"
            label="作废时间"
          ></el-table-column>
          <el-table-column prop="stop_state" label="暂停状态"></el-table-column>
        </el-table>
      </div>
      <div class="page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, prev, pager, next, jumper"
          :total="total_num"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { newCouponVerifiy, coupon_receive_index } from "@/api/coupon";
export default {
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  props: ["uid"],
  watch: {
    uid(val) {
      console.log("uid", val);
      this.getLists();
    },
  },
  data() {
    return {
      loading: true,
      getType: [
        {
          name: "全部",
          value: "",
        },
        {
          name: "领取",
          value: "1",
        },
        {
          name: "发放",
          value: "0",
        },
        {
          name: "赠送",
          value: "2",
        },
      ],
      timeType: [
        {
          name: "全部",
          value: "0",
        },
        {
          name: "最近7天",
          value: "7",
        },
        {
          name: "最近30天",
          value: "30",
        },
        {
          name: "本月",
          value: "31",
        },
        {
          name: "自定义",
          value: "z",
        },
      ],
      is_used: "1", //使用状态
      is_cancle: "", //核销状态 0 用户使用 1 扫码核销
      get_type: "1", //领取方式
      page: "1",
      total_num: 0,
      tableData: [],
      formLabelWidth: "120px",
      dialogFormVisible: false,
      params: {
        time: "z",
        getType: "1", // 支付方式
      }, //查询参数
      dateValue: [], //消费时间
      timeValue: [],
      options: [
        {
          value: "0",
          label: "用户使用",
        },
        {
          value: "1",
          label: "扫码核销",
        },
      ],
      typeOptions: [
        {
          value: "0",
          label: "平台发放",
        },
        {
          value: "1",
          label: "用户领取",
        },
      ],
      value: "",
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000",
      },
    };
  },
  mounted() {
    // this.getLists();
  },
  methods: {
    chongzhi() {
      this.params.getType = "";
      this.dateValue = [];
      this.timeValue = [];
      this.page = 1;
      this.getLists();
    },
    changeGet() {
      this.getLists();
    },
    // 时间筛选
    timeSearch() {
      if (!this.dateValue[0]) {
        this.$message("未选择开始时间");
      } else if (!this.dateValue[1]) {
        this.$message("未选择结束时间");
      } else if (
        new Date(this.dateValue[0]).getTime() >
        new Date(this.dateValue[1]).getTime()
      ) {
        this.$message("开始时间不能大于结束时间");
      } else {
        this.getLists();
      }
    },
    // 设置表头颜色
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    addSlice() {
      this.$router.push({
        path: `adSign`,
      });
    },
    // 核销记录
    getLists() {
      this.loading = true;
      let data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        uid: this.uid,
      };
      data.get_type = this.params.getType;
      // if (this.params.getType == "1") {

      // } else if (this.params.getType == "2") {
      //   data.get_type = 0;
      // } else if (this.params.getType == "3") {
      //   data.is_used = 1;
      // } else if (this.params.getType == "4") {
      //   data.is_exp = 1;
      // } else if (this.params.getType == "5") {
      //   data.is_cancle_time = 1;
      // }
      // if (this.params.time == "z") {
      if (this.dateValue !== null && this.dateValue.length !== 0) {
        data.get_time_s = this.timeValue[0]
          ? this.dateValue[0] + " " + this.timeValue[0]
          : this.dateValue[0] + " 00:00:00";
        data.get_time_e = this.timeValue[1]
          ? this.dateValue[1] + " " + this.timeValue[1]
          : this.dateValue[1] + " 23:59:59";
      }
      // }
      // else if (this.params.time == "7") {
      //   data.seven_day = 1;
      // } else if (this.params.time == "30") {
      //   data.thirty_day = 1;
      // } else if (this.params.time == "31") {
      //   // 本月
      //   data.month_time = 1;
      // }
      coupon_receive_index(data).then((res) => {
        console.log("sss", res);
        this.loading = false;
        if (res.code == 200) {
          this.tableData = res.data.result;
          this.total_num = res.data.total_num;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.page = val;
      this.getLists();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getLists();
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 26px 11px 20px;
  overflow: auto;
  min-width: 900px;
  border: node;
  // background: rgba(240, 242, 245, 1);
  .inner_content {
    background: #fff;
    padding: 0 24px;
    height: 100%;
    display: flex;
    flex-direction: column;
    .header {
      padding-top: 20px;
      margin-bottom: 20px;
      .box {
        width: 330px;
        .title {
          min-width: 100px;
          text-align: right;
        }
        .fixedwidth {
          width: 180px;
          display: flex;
          justify-content: space-between;
        }
      }
    }
    // 搜索
    .date_picker_box {
      width: 130px;
    }
    .time_picker_box {
      width: 120px;
      margin-right: 8px;
    }
    .bottom {
      flex: 1;
      overflow-y: scroll;
    }
    .page {
      height: 50px;
      display: flex;
      align-items: center;
    }
  }
}
// 通用样式
.flex {
  display: flex;
  align-items: center;
  padding: 10px 0px;
}
</style>
